import { render, staticRenderFns } from "./Sistemas.vue?vue&type=template&id=29319aac&"
import script from "./Sistemas.vue?vue&type=script&lang=js&"
export * from "./Sistemas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports